import forge from 'apis/forge';
import { Scene } from 'dragonmouse-shared/interfaces';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import Modal from '../..';
import UserAccessManager from '../UserAccessManager';

interface SceneUserManagerModalProps {
	scene: Scene;
	onBack: () => void;
	onClose: () => void;
}

const SceneUserManagerModal = ({ scene, onBack, onClose }: SceneUserManagerModalProps) => {
	const { user } = useSelector((r: RootReducer) => {
		return {
			user: selectUser(r.db),
		};
	});

	const close = useCallback(() => {
		onClose();
	}, [onClose]);

	return (
		<Modal
			title="Manage Project Editors"
			cancelLabel="Close"
			submitLabel="Save"
			onBack={onBack}
			onClose={close}
		>
			<UserAccessManager
				entityId={scene.id}
				getUsers={async (id: string) => {
					return await forge.getSceneUsers({ sceneId: id });
				}}
				grantAccess={async (id: string, emails: string[]) => {
					await forge.grantSceneAccess.withToast()({ sceneId: id, emails });
				}}
				revokeAccess={async (id: string, email: string) => {
					await forge.revokeSceneAccess.withToast()({ sceneId: id, email });
				}}
				onAccessGranted={() => {
					// Update user metadata for analytics
					if (user?.id) {
						forge.updateUser({
							update: {
								id: user.id,
								metadata: {
									lastSharedDate: new Date().toISOString(),
								},
							},
						});
					}
				}}
				errorMessages={{
					fetchFailed: 'Failed to fetch scene users',
					revokeFailed: 'Failed to revoke user access',
				}}
			/>
		</Modal>
	);
};

export default SceneUserManagerModal;
